import { startCase } from 'lodash-es';
import { useMemo } from 'react';
import { envConfig } from '../utils/envConfig';
import { useFeatureFlag } from './useFeatureFlag';

export function computeBaseTitle(clientTitle: string | undefined): string {
  const env = envConfig.VITE_AVA_ENV;
  const isProd = env === 'prod';
  const name = clientTitle?.trim() || (isProd ? 'Talos Trading' : 'Talos');
  return isProd ? name : `${name} (${startCase(env)})`;
}

export function useBaseTitle(): string {
  const { clientTitle } = useFeatureFlag();

  return useMemo(() => computeBaseTitle(clientTitle), [clientTitle]);
}
